import { blue, green, orange, purple, red, yellow } from "@faro-lotv/flat-ui";
import { HoloBuilderColors } from "@faro-lotv/ielement-types";

/** The colors used for rendering the waypoints, based on the palette of SphereXG */
export const SphereXGColors = {
  Red: red[500],
  Orange: orange[400],
  Yellow: yellow[300],
  Green: green[600],
  Blue: blue[500],
  Purple: purple[500],
} as const;

/**
 * @returns The color from the palette of Sphere XG mapped from the input HoloBuilder color
 * @param color The HoloBuilder color to convert
 */
export function holoBuilderColorToSphereXGColor(
  color: HoloBuilderColors,
): (typeof SphereXGColors)[keyof typeof SphereXGColors] {
  switch (color) {
    case HoloBuilderColors.Red:
      return SphereXGColors.Red;
    case HoloBuilderColors.Orange:
      return SphereXGColors.Orange;
    case HoloBuilderColors.Yellow:
      return SphereXGColors.Yellow;
    case HoloBuilderColors.Green:
      return SphereXGColors.Green;
    case HoloBuilderColors.Blue:
      return SphereXGColors.Blue;
    case HoloBuilderColors.Purple:
      return SphereXGColors.Purple;
  }
}

/**
 * @returns The color from the palette of HoloBuilder mapped from the input Sphere XG color
 * @param color The Sphere XG color to convert
 */
export function sphereXGToHolobuilderColors(
  color: (typeof SphereXGColors)[keyof typeof SphereXGColors],
): HoloBuilderColors {
  switch (color) {
    case SphereXGColors.Red:
      return HoloBuilderColors.Red;
    case SphereXGColors.Orange:
      return HoloBuilderColors.Orange;
    case SphereXGColors.Yellow:
      return HoloBuilderColors.Yellow;
    case SphereXGColors.Green:
      return HoloBuilderColors.Green;
    case SphereXGColors.Blue:
      return HoloBuilderColors.Blue;
    case SphereXGColors.Purple:
      return HoloBuilderColors.Purple;
  }
}
